export const auth = {
  authHomeTitle: 'Вітаємо!',
  authHomeButtonBranded: 'Продовжити з Email',
  authHomeButtonApple: 'Продовжити з Apple',
  authHomeButtonGoogle: 'Продовжити з Google',
  authHomeButtonFacebook: 'Продовжити з Facebook',
  authHomeButtonLinkedin: 'Продовжити з LinkedIn',
  authStartTitle: 'Введіть E-mail',
  authStartInputTitle: 'E-mail',
  authStartInputTitleError: 'Введіть правильний E-mail!',
  authStartInputPasswordError: 'Введіть правильний Пароль!',
  authWhoops: 'Лишенько!',
  authStartConfirmButton: 'Продовжити',
  authRegisteredTitle: 'З поверненням!',
  authStartPlaceholderTitle: 'E-mail',
  authRegisteredInputTitle: 'Пароль',
  authRegisteredForgotPassword: 'Забули пароль',
  authAlertIncorrectPassword: 'Ваша пошта або пароль неправильні',
  authAlertRequiredPassword: 'Введіть правильний Пароль',
  authFinishSignUpTitle: 'Завершіть реєстрацію',
  authFinishSignUpEmailInputTitle: 'E-mail',
  authFinishSignUpFirstNameInputTitle: 'Імʼя',
  authFinishSignUpLastNameInputTitle: 'Прізвище',
  authFinishSignUpPasswordInputTitle: 'Пароль',
  authFinishSignUpTipContent:
    '<ul class="text-14 pl-4 text-black"><li class="-ml-4 list-none">Ми рекомендуємо використовувати:</li><li class="list-disc">Мінімум 8 символів</li><li class="list-disc">Хоча б 1 цифру</li><li class="list-disc">Хоча б 1 спеціальний символ</li></ul>',
  authFinishSignUpPrivacyAndTerms: {
    text1: 'Натискаючи Зареєструватися ви погоджуєтесь з нашими',
    privacyPolicy: 'Privacy Policy',
    text2: 'та',
    termsOfUse: 'Terms of Use'
  },
  authFinishSignUpConfirmButton: 'Зареєструватися',
  authFinishSignUpErrorFirstName: 'Імʼя не може бути пустим!',
  authFinishSignUpErrorLastName: 'Прізвище не може бути пустим!',
  authFinishSignUpErrorPassword: 'Ви обрали дуже короткий пароль!',
  authEmailConfirmationTitle: 'Перевірте свою електронну пошту',
  authEmailConfirmationContent:
    'Ми надіслали електронний лист із підтвердженням, щоб підтвердити вашу електронну адресу. Будь ласка, перевірте свою скриньку зі спамом, якщо ви не можете знайти лист у своїй основній папці',
  authEmailConfirmationConfirmButton: 'Перейти на головний екран',
  authAlertEmailConfirmation: 'Ви досі не підтвердили свою пошту - перевірте свою електронну скриньку!',
  authResetPasswordTitle: 'Перевірте свою електронну пошту',
  authResetPasswordDescription:
    'Ми надіслали посилання на скидання паролю на вашу пошту. Будь ласка, перевірте свою скриньку зі спамом, якщо ви не можете знайти лист у своїй основній папці',
  authResetPasswordButton: 'На головну',
  authNewPasswordTitle: 'Введіть новий пароль',
  authNewPasswordInputTitle: 'Новий пароль',
  authNewPasswordButton: 'Скинути пароль',
  authNewPasswordAlertValidation: 'Ваш пароль занадто легкий!',
  authPasswordChangeSuccessTitle: 'Пароль змінено!',
  authPasswordChangeSuccessContent: 'Ви успішно змінили свій пароль!',
  authPasswordChangeSuccessButton: 'На головну',
  authPasswordChangeErrorTitle: 'Сталася помилка!',
  authPasswordChangeErrorContent: 'Щось пішло не так під час спроби скидання вашого паролю! Спробуйте пізніше.',
  authPasswordChangeErrorButton: 'На головну',
  authInvitationTitle: 'Оберіть собі пароль',
  authInvitationInputTitle: 'Пароль',
  authInvitationButton: 'Обрати пароль',
  authEmailAddressConfirmed: 'Ви підтвердили свою пошту!'
}
